import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var notificationRes;
export const notificationTodo = createAsyncThunk('notification', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + '/get_notification',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return notificationRes = res.data
    } catch (error) {
        return notificationRes = error.response.data
    }
})


const notificationSlice = createSlice({
    name: 'notification',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(notificationTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('notification', state.data)
            }
        });
        builder.addCase(notificationTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default notificationSlice.reducer; 